module.exports = __webpack_public_path__ + "static/media/Wiki.02bd8c32.svg";